import React, { useEffect, useState } from "react";
import "./FinalizeBid.css";
import GreenTick from "../../../assets/img/GreenTick.png";
import { Row, Col } from "antd";
import JobCard from "../../JobCard/JobCard";
import CandidateCard from "../CandidateCard/CandidateCard";
import { getImageByStateCode } from "../../../pages/CompanyProfile/components/cloudinary";
import moment from "moment";
import { useSelector } from "react-redux";


const budgetOptions = [
	{
		BudgetTypeId: 3,
		BudgetTypeName: "Month",
		BudgetType: "mn",
	},
	{
		BudgetTypeId: 1,
		BudgetTypeName: "Hour",
		BudgetType: "hr",
	},
	{
		BudgetTypeId: 5,
		BudgetTypeName: "Daily",
		BudgetType: "daily",
	},
	{
		BudgetTypeId: 2,
		BudgetTypeName: "Week",
		BudgetType: "wk",
	},
	{
		BudgetTypeId: 4,
		BudgetTypeName: "Year",
		BudgetType: "yr",
	},
];

const contractOptions = [
	{
		IdealContractLengthId: 1,
		IdealContractLengthName: "1 month",
		IdealContractLengthValue: 1,
	},
	{
		IdealContractLengthId: 2,
		IdealContractLengthName: "2 months",
		IdealContractLengthValue: 2,
	},
	{
		IdealContractLengthId: 3,
		IdealContractLengthName: "3 months",
		IdealContractLengthValue: 3,
	},
	{
		IdealContractLengthId: 4,
		IdealContractLengthName: "4 months",
		IdealContractLengthValue: 4,
	},
	{
		IdealContractLengthId: 5,
		IdealContractLengthName: "5 months",
		IdealContractLengthValue: 5,
	},
	{
		IdealContractLengthId: 6,
		IdealContractLengthName: "6 months",
		IdealContractLengthValue: 6,
	},
	{
		IdealContractLengthId: 7,
		IdealContractLengthName: "7 months",
		IdealContractLengthValue: 7,
	},
	{
		IdealContractLengthId: 8,
		IdealContractLengthName: "8 months",
		IdealContractLengthValue: 8,
	},
	{
		IdealContractLengthId: 9,
		IdealContractLengthName: "9 months",
		IdealContractLengthValue: 9,
	},
	{
		IdealContractLengthId: 10,
		IdealContractLengthName: "10 months",
		IdealContractLengthValue: 10,
	},
	{
		IdealContractLengthId: 11,
		IdealContractLengthName: "11 months",
		IdealContractLengthValue: 11,
	},
	{
		IdealContractLengthId: 12,
		IdealContractLengthName: "1 year",
		IdealContractLengthValue: 12,
	},
	{
		IdealContractLengthId: 13,
		IdealContractLengthName: "1+ years",
		IdealContractLengthValue: 13,
	},
	{
		IdealContractLengthId: 14,
		IdealContractLengthName: "Negotiable",
		IdealContractLengthValue: 14,
	},
	{
		IdealContractLengthId: 15,
		IdealContractLengthName: "13 weeks",
		IdealContractLengthValue: 15,
	},
	{
		IdealContractLengthId: 16,
		IdealContractLengthName: "1 Week",
		IdealContractLengthValue: 16,
	},
	{
		IdealContractLengthId: 17,
		IdealContractLengthName: "6 weeks",
		IdealContractLengthValue: 17,
	},
	{
		IdealContractLengthId: 18,
		IdealContractLengthName: "12 weeks",
		IdealContractLengthValue: 18,
	},
];

export default function FinalizeBid(props) {
	const bidData = useSelector((state) => state.createBidReducers.bidData);
	const editBidData = useSelector((state) => state.updateBidReducers.success);
	const [array, setArray] = useState(false);
	const [dimensions, setDimensions] = useState(window.innerWidth);
  const selectedData = JSON.parse(localStorage.getItem("selectedGigDetails"));

	useEffect(() => {
		setArray(Array.isArray(bidData));
	}, [bidData]);

	//********** convert encrypted html code to HTML tags **********
	var cache = {},
		character,
		e = document.createElement("div");

	const msgtxt = (html) => {
		return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
			character = cache[entity];
			if (!character) {
				e.innerHTML = entity;
				if (e.childNodes[0])
					character = cache[entity] = e.childNodes[0].nodeValue;
				else character = "";
			}
			return character;
		});
	};
	const userSKillListing = useSelector(
        (state) => state.oneUserskillListingReducer.skillListings
    );

	//*********************************************//
	return (
    <div className="finalizeBid">
      <Row className="tickContainer-FB">
        <img src={GreenTick} alt="Tick" className="tickImg" />
      </Row>
      <div className="headingText">
        {props.EditBid
          ? `Bid successfully updated on Candidate`
          : `Bid successfully placed on Candidate`}
      </div>
      <Row className="rate-container">
        <div className="rate-text">
          {props.currencyType == "USD" || props.currencyType == "CAD"
            ? "$"
            : props.currencyType == "INR"
            ? "₹"
            : "₱"}{" "}
          {/* {editBidData?.Rate
            ? editBidData?.Rate
            : array
            ? bidData[0]?.Rate
            : bidData?.Rate} */}
          {bidData?.Rate
            ? (+bidData?.Rate ?? 0).toFixed(2)
            : bidData && bidData[0]?.Rate
            ? (+bidData[0]?.Rate ?? 0).toFixed(2)
            : editBidData?.data?.Rate
            ? (+editBidData?.data?.Rate ?? 0).toFixed(2)
            : null}
          /
          {bidData?.BudgetTypeId
            ? budgetOptions?.find((o) => {
                return o.BudgetTypeId === bidData?.BudgetTypeId;
              })?.BudgetType
            : bidData && bidData[0]?.BudgetTypeId
            ? budgetOptions?.find((o) => {
                return o.BudgetTypeId === bidData[0]?.BudgetTypeId;
              })?.BudgetType
            : editBidData?.data?.BudgetTypeId
            ? budgetOptions?.find((o) => {
                return o.BudgetTypeId === editBidData?.data?.BudgetTypeId;
              })?.BudgetType
            : null}
          {/* {editBidData?.BudgetType == "Hour"
            ? "hr"
            : "WK" ?? props.rateType == "week"
          ?"WK"
            : "hr"} */}
        </div>
      </Row>
      <Row className="detailsContainer">
        <Row className="detailsText-Space">
          <div className="textBold">Ideal start date</div>
          <div className="textRegular">
            {moment(
              bidData?.IdealStartDate
                ? bidData?.IdealStartDate
                : bidData && bidData[0]?.IdealStartDate
                ? bidData && bidData[0]?.IdealStartDate
                : editBidData?.data?.IdealStartDate
                ? editBidData?.data?.IdealStartDate
                : null

              // bidData?.IdealStartDate
            ).format("MMMM DD, YYYY")}
          </div>
        </Row>
        {props.jobOrderTypeName === "Permanent" ? (
          <></>
        ) : (
          <Row className="detailsText-Space marginTB">
            <div className="textBold">Contract length </div>
            <div className="textRegular">
              {bidData?.IdealTerm
                ? contractOptions?.find((o) => {
                    return o.IdealContractLengthId === bidData?.IdealTerm;
                  }).IdealContractLengthName
                : bidData && bidData[0]?.IdealTerm
                ? contractOptions?.find((o) => {
                    return o.IdealContractLengthId === bidData[0]?.IdealTerm;
                  }).IdealContractLengthName
                : editBidData?.data?.IdealTerm
                ? contractOptions?.find((o) => {
                    return (
                      o.IdealContractLengthId === editBidData?.data?.IdealTerm
                    );
                  }).IdealContractLengthName
                : null}
            </div>
          </Row>
        )}

        <Row className="marginTB">
          <div className="textBold">Bid message</div>
        </Row>
        <Row className="msgContainer">
          <div
            className="msgContainer-div"
            dangerouslySetInnerHTML={{
              __html: msgtxt(
                bidData?.Comments ??
                  (bidData && bidData[0]?.Comments) ??
                  editBidData?.data?.Comments
              ),
            }}
          ></div>
        </Row>
      </Row>
      <Row>
        <div
          className="headingTextBold"
          style={{
            margin: dimensions < 768 ? "20px 0px 0px 0px" : "56px 0px 0px 0px",
          }}
        >
          Job Detail
        </div>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <JobCard
          rating={props?.selectedGigDetails?.facilityRating?.rating}
            isPrivate={props?.selectedGigDetails?.isPrivate}
            img={
              props?.fromMatches == true && props?.jobdetails?.length
                ? props?.jobdetails[0]?.Regions?.Code !== null &&
                  props?.jobdetails[0]?.Cities?.CityName !== null
                  ? getImageByStateCode(
                      props?.jobdetails[0]?.Regions?.Code,
                      props?.jobdetails[0]?.Cities?.CityName,
                      props?.jobdetails[0]?.CompanyName
                    )
                  : ""
                : props?.selectedGigDetails?.Regions?.Code !== null &&
                  props?.selectedGigDetails?.Cities?.CityName !== null
                ? getImageByStateCode(
										props?.selectedGigDetails?.Regions?.Code || selectedData?.Regions?.Code,
										props?.selectedGigDetails?.Cities?.CityName || selectedData?.Cities?.CityName,
										props?.selectedGigDetails?.CompanyName || selectedData?.CompanyName ,
								  )
								: ""
            }
            RegionCode={
              props.fromMatches == true
                ? props.jobdetails[0]?.Regions?.Code
                : props?.selectedGigDetails?.Regions?.Code
            }
            CityName={
              props.fromMatches == true
                ? props.jobdetails[0]?.Cities?.CityName
                : props?.selectedGigDetails?.Cities?.CityName
            }
            id={
              props.fromMatches == true
                ? props.jobdetails[0]?._id
                : props.selectedGigDetails?._id
            }
            location={
              props.fromMatches == true
                ? props?.jobdetails[0]?.Location?.LocationWithCountry
                : props?.selectedGigDetails?.Location?.LocationWithCountry
            }
            title={
              props.fromMatches == true
                ? props.jobdetails[0]?.Title
                : props.selectedGigDetails?.Title ? props.selectedGigDetails?.Title  
                : selectedData?.Title
            }
            facilityname={
              props.fromMatches == true
                ? props.jobdetails[0]?.FacilityName
                : props.selectedGigDetails?.FacilityName
            }
            budget={
              props.fromMatches == true
                ? props.jobdetails[0]?.BudgetMin
                : props.selectedGigDetails?.BudgetMin
            }
            budgetType={
              props.fromMatches == true
                ? props.jobdetails[0]?.BudgetTypes?.BudgetTypeCode
                : props?.BudgetTypes?.BudgetTypeCode
            }
            rate={
              props.fromMatches == true
                ? props.jobdetails[0]?.BudgetType
                : props.selectedGigDetails?.BudgetType
            }
            cardFooter={false}
            fromDashboard={true}
            created={
              props.fromMatches === true
                ? props.jobdetails[0]?.Created
                : props.selectedGigDetails?.Created
                ? props.selectedGigDetails.Created
                : bidData?.Gig?.Created
            }
          />
        </Col>
      </Row>
      <Row>
        <div
          className="headingTextBold"
          style={{
            margin: "30px 0px 0px 0px",
          }}
        >
          Candidates
        </div>
      </Row>
      <Row style={{ display: "flex" }}>
        {props.candidateList.map((item, index) => {
          return (
            <Col xs={12} sm={12} md={12} lg={8} xl={8} key={index}>
              <CandidateCard
                rating={props?.rating}
                img={item.img}
                name={item.name}
                title={item.title}
                experience={item.experience}
                desired_rate={item.desired_rate}
                bidType={item.bidType}
                profileType={item.profileType}
                lastActive={item.lastActive}
                closeIcon={false}
                AccountID={item?.AccountId}
                email={
                  userSKillListing?.skill_listings?.Profiles?.Accounts
                    ?.EmailAddress
                }
                MobilePhone={item.MobilePhone}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
